import { ErrorAlert } from '../../components/alerts';
import { KioskAttractorsResponse } from '../../types';
import AttractorImageSettingsContainer from './AttractorImageSettingsContainer';

type Props = {
  errorMessage: string;
  data: KioskAttractorsResponse[];
  getAttractors: () => void;
};
const MultipleAttractorsContainer = ({
  errorMessage,
  data,
  getAttractors,
}: Props) => {
  if (data?.length === 0) {
    return <ErrorAlert message={errorMessage} />;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {data?.map((d, i) => (
        <div key={i}>
          <AttractorImageSettingsContainer
            d={d}
            getAttractors={getAttractors}
          />
        </div>
      ))}
    </div>
  );
};

export default MultipleAttractorsContainer;
